import { ReactNode } from 'react';
import { Card } from './ui';
import { cn } from '../lib/utils';

type ListFiltersBarProps = {
  children?: ReactNode;
  /** Primary actions (Νέο…, Εξαγωγή, Αναζήτηση) aligned to the end. */
  actions?: ReactNode;
  className?: string;
};

/**
 * Compact filter toolbar for list/report modules.
 * Uses a responsive auto-fit grid so controls sit in one dense row
 * instead of stacking full-width.
 */
export function ListFiltersBar({
  children,
  actions,
  className,
}: ListFiltersBarProps) {
  return (
    <Card className={cn('shrink-0 p-3 sm:px-4 sm:py-3', className)}>
      <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:gap-4">
        {children ? (
          <div
            className={cn(
              'grid min-w-0 flex-1 items-end gap-2.5',
              '[grid-template-columns:repeat(auto-fit,minmax(10.5rem,1fr))]',
            )}
          >
            {children}
          </div>
        ) : (
          <div className="min-w-0 flex-1" />
        )}
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2 lg:justify-end">
            {actions}
          </div>
        ) : null}
      </div>
    </Card>
  );
}

type FilterFieldProps = {
  label?: string;
  children: ReactNode;
  className?: string;
  /** Span ~2 columns (search fields). */
  wide?: boolean;
};

export function FilterField({
  label,
  children,
  className,
  wide = false,
}: FilterFieldProps) {
  return (
    <div
      className={cn(
        'min-w-0',
        wide && 'sm:[grid-column:span_2]',
        className,
      )}
    >
      {label ? (
        <div className="mb-1 truncate text-xs font-medium text-ink-muted">
          {label}
        </div>
      ) : null}
      {children}
    </div>
  );
}
